import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from '@kpmg-tax/ui';
import { LegalEntitiesService } from 'src/app/data-analysis-summary/legal-entity/legal-entity.service';
import { API_URL } from '../../constants/apiurl-constants';
import { Messages } from '../../constants/messages';
import { encodeText } from '../../lib/custom-tools';
import { BaseResponse } from '../../models/base-response.model';
import { LegalEntities } from '../../models/legal-entity/legal-entity.model';
import { SessionService } from '../../session-service/session.service';
import { RightSideDrawerService } from '../right-side-drawer.service';

@Component({
  selector: 'edit-an-entity',
  templateUrl: './edit-an-entity.component.html',
  styleUrls: ['./edit-an-entity.component.scss']
})
export class EditAnEntityComponent implements OnInit {
  targetForm: FormGroup;
  _Entity: any;
  _singlerow: any;
  isDisabled: boolean = false;
  engagementId: number;
  entitynameNoError: boolean=false;
  isEntityValueEntered: boolean=false;
  valchanged: boolean=false;
  constructor(public rightSideDrawerService:RightSideDrawerService,
    private sessionService:SessionService,private _toasterService:ToastrService,
    private _legalEntityService:LegalEntitiesService) { }

  public resetRightSideDrawerData = () => {
    
    this.targetForm = new FormGroup({

      
      legalEntityName: new FormControl(
        this.rightSideDrawerService.singleRowEditData.legalEntityName,
        [
          Validators.required
        ],
      ),

      ein: new FormControl(
        this.rightSideDrawerService.singleRowEditData.ein
      ),
      businessactivitycode: new FormControl(
        this.rightSideDrawerService.singleRowEditData.businessActivityCode
      )
    
  })
}

  get f() {
    return this.targetForm?.controls;
  }

  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
    );
  }

  UniqueEntityNameUpdate(entityList: any, row: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const entityName = this.trim(control.value).toUpperCase();
      if (
        row.name.toUpperCase() !== entityName &&
        entityList.find(x => x.name.toUpperCase() === entityName)
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  trim(x) {
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  }

  ngOnInit() {
    this.engagementId = parseInt(this.sessionService.getSession('engagementId'));
    this._Entity = this.rightSideDrawerService.multipleRowAddData;
    this._singlerow = this.rightSideDrawerService.singleRowEditData;
    this.resetRightSideDrawerData();
    //this.getAllActivities(this.engagementId);
  }

  get inputEntityName(): string {
    return this.targetForm.get('legalEntityName').value?.toString().trim();
  }

  checkEntityName() {
    let  entityname = this._Entity.filter(x => x.legalEntityName.toUpperCase() === this.inputEntityName.toUpperCase())
   if(entityname.length>0 && entityname.find(x=>x.legalEntityName).legalEntityName !=this.rightSideDrawerService.singleRowEditData.legalEntityName)
   {
     this.entitynameNoError=true;
   }
   else
   {
    this.entitynameNoError=false;
   }
    
  }
  valueChanged() {
    let entityName = this.targetForm.get('legalEntityName').value;
    
    if (
      entityName &&
      entityName.trim().length > 0
      
    ) {
      this.isEntityValueEntered = true;
    } else {
      this.isEntityValueEntered = false;
      this.valchanged=false;
    }
  }
  checkInput()
  {
    
    let entityNamet = this.targetForm.get('legalEntityName').value.trim();   
     let eint=this.targetForm.get('ein').value== ''?null:this.targetForm.get('ein').value ;
     let bact=this.targetForm.get('businessactivitycode').value==''?
     null:this.targetForm.get('businessactivitycode').value
    eint=eint!=null? eint.trim():eint;
    bact=bact!=null?bact.trim():bact;
    if( entityNamet &&
      entityNamet.trim().length > 0 && entityNamet.trim()!=this.rightSideDrawerService.singleRowEditData.legalEntityName ||
   (eint!=='' && this.rightSideDrawerService.singleRowEditData.ein !=eint) || 
   (bact!=='' && this.rightSideDrawerService.singleRowEditData.businessActivityCode!=
    bact) )
    {
      this.valchanged=true;
      this.isEntityValueEntered = true;
    }
    else{
      this.valchanged=false;
    }
  }
  editEntity = () => {
    this.isDisabled=true;
    let entity: any = {
      LegalEntityId: this.rightSideDrawerService.singleRowEditData.legalEntityId,
      LegalEntityName: encodeText(this.targetForm.get('legalEntityName').value?.trim()), 
      ein: this.targetForm.get('ein').value===null
        ? null
        : encodeText(this.targetForm.get('ein').value.trim()),       
      BusinessActivityCode: this.targetForm.get('businessactivitycode').value === null
        ? null
        : encodeText(this.targetForm.get('businessactivitycode').value.trim()),      
      engagementId: this.engagementId,
    };

    if (entity.LegalEntityId === 0) {
      this.rightSideDrawerService.closeRightSideDrawer();
      return;
    }
    entity = this.sessionService.removeNullEmptyValues(entity);
    this.sessionService.apiUrlPost(API_URL.LEGAL_ENTITY.EDIT_ENTITY, entity).subscribe((data: BaseResponse) => {
      if (data !== null && data.success) {
        
        this._legalEntityService.refreshTable();
        let tabledata: Array<LegalEntities> = this._legalEntityService
          .legalEntities;
        
        tabledata.unshift(data.result);
        this._legalEntityService.legalEntities = [...tabledata];
        this.rightSideDrawerService.closeRightSideDrawer();
        this._toasterService.setSuccessMessage(Messages.LEGAL_ENTITY.EDIT_ENTITY)
    } else{
      this.rightSideDrawerService.closeRightSideDrawer();
    }}
   
    );
  }
}
